var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFlash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    viewBox: "0 0 284 284",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.8,73.5c.6-2.1,2.6-3.6,4.8-3.6h40c2.8,0,5,2.2,5,5s0,1.1-.3,1.6l-17.8,53.4h38.1c2.8,0,5,2.2,5,5s-.4,2.2-1.1,3.1l-70,90c-1.7,2.2-4.8,2.6-7,.9-1.6-1.3-2.3-3.4-1.7-5.4l18-58.5h-33.2c-2.8,0-5-2.2-5-5s.1-1,.2-1.4c0-.1,25-85.1,25-85.1ZM129.4,79.9l-22.1,75h33.3c2.8,0,5,2.2,5,5s0,1-.2,1.5l-12,38.9,47-60.4h-34.8c-2.8,0-5-2.2-5-5s.1-1.1.3-1.6l17.8-53.4h-29.3Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flash.9fb1dae8.svg";
export { ForwardRef as ReactComponent };